import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Box, CssBaseline, ThemeProvider, Paper } from '@mui/material';
// theme
import { theme } from './theme'
// components
import Header from 'components/Header/Header';
// pages
import Search from 'pages/Search';
import NotFound from 'pages/NotFound';
import Articles from 'pages/Articles';
import EventCalendar from 'pages/EventCalendar';
import HistoryList from 'pages/HistoryList';
// markdowns
import About from 'articles/about.md';
import AboutOFM from 'articles/about_old_frame_modern.md';
import Donate from 'articles/donate.md';

const App = () => {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Header />
        <Box sx={{
          maxWidth: 1000,
          marginLeft: 'auto',
          marginRight: 'auto',
        }}>
          <Paper
            sx={{
              paddingX: 3,
              paddingY: 10,
              maxWidth: 1000,
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >

            <Routes>
              <Route index element={<Search />} />
              <Route path="about" element={<Articles mdAlias={About} />} />
              <Route path="aboutofm" element={<Articles mdAlias={AboutOFM} />} />
              <Route path="donate" element={<Articles mdAlias={Donate} />} />
              {/* <Route path="calender" element={<EventCalendar />} /> */}
              <Route path="history" element={<HistoryList />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Paper>
        </Box>
      </ThemeProvider>
    </BrowserRouter >
  );
};

export default App;
